module.exports = __webpack_public_path__ + "static/media/离合器及变速器.ca3911ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/dongfeng/faultDiagnosis/demo/image/离合器及变速器.png
// module id = 1714
// module chunks = 174